export enum ScreeningStatusId {
  Other = 0,
  Approved = 1,
  ApprovedWithConditions,
  Declined,
  FurtherReview,
  Pending,
  GuarantorRequired,
  DocumentSubmissionCompleted,
  Retry,
  ProblemResolution,
  ApprovedWithConditionsMet,
  LowAccept,
  Conditional,
  Error,
}

export const ScreeningStatusMap = {
  0: "Other",
  1: "Approved",
  2: "Approved With Conditions",
  3: "Declined",
  4: "Further Review",
  5: "Pending",
  6: "Guarantor Required",
  7: "Document Submission Completed",
  8: "Retry",
  9: "Problem Resolution",
  10: "Approved With Conditions (Conditions Met)",
  11: "Low Accept",
  12: "Conditional",
  13: "Error",
};

export enum ScreeningStatus {
  Other = "Other",
  Approved = "Approved",
  LowAccept = "LowAccept",
  Conditional = "Conditional",
  ApprovedWithConditions = "ApprovedWithConditions",
  Declined = "Declined",
  FurtherReview = "FurtherReview",
  Pending = "Pending",
  Retry = "Retry",
  ProblemResolution = "ProblemResolution",
  ApprovedWithConditionsMet = "ApprovedWithConditionsMet",
  Error = "Error",
}

export const MapScreeningEnumTypeToScreeningStatusId = {
  Approved: ScreeningStatusMap[ScreeningStatusId.Approved],
  LowAccept: ScreeningStatusMap[ScreeningStatusId.LowAccept],
  Conditional: ScreeningStatusMap[ScreeningStatusId.Conditional],
  Error: ScreeningStatusMap[ScreeningStatusId.Error],
  ApprovedWithConditions:
    ScreeningStatusMap[ScreeningStatusId.ApprovedWithConditions],
  Declined: ScreeningStatusMap[ScreeningStatusId.Declined],
  FurtherReview: ScreeningStatusMap[ScreeningStatusId.FurtherReview],
  Pending: ScreeningStatusMap[ScreeningStatusId.Pending],
  GuarantorRequired: ScreeningStatusMap[ScreeningStatusId.GuarantorRequired],
  DocumentSubmissionCompleted:
    ScreeningStatusMap[ScreeningStatusId.DocumentSubmissionCompleted],
  Retry: ScreeningStatusMap[ScreeningStatusId.Retry],
  ProblemResolution: ScreeningStatusMap[ScreeningStatusId.ProblemResolution],
  ApprovedWithConditionsMet:
    ScreeningStatusMap[ScreeningStatusId.ApprovedWithConditionsMet],
  Other: ScreeningStatusMap[ScreeningStatusId.Other],
};

// Mirrors LeaseDomain's alert type enum (LeaseDomain.API#1194, which superseded
// the earlier document/identity-based enum from #1159) - alertType is just the
// capitalized Issue.type category, not a separate taxonomy (see AdminDashService.ts).
export enum ScreeningAlertType {
  Credit = "Credit",
  Ssn = "Ssn",
  Address = "Address",
}

export interface Issue {
  id: number;
  applicantScreeningId: number;
  type: string;
  description: string;
  resolved: boolean;
}

export const ScreeningTypes = {
  credit: "Credit",
  ssn: "SSN",
  address: "Address",
};

export const ScreeningDocumentResult = {
  passed: "Passed",
  insufficientDocumentation: "Insufficient Documentation",
  failed: "Failed",
  resubmittedPassed: "Resubmitted - Passed",
  resubmittedInsufficient: "Resubmitted - Insufficient",
  resubmittedFailed: "Resubmitted - Failed",
  pendingDocumentationVerification: "Pending Document Verification",
  furtherReview: "Action Required",
};
